module.exports = __webpack_public_path__ + "static/media/confianza.9327e302.svg";